export default __webpack_public_path__ + "static/media/drawer-rocket.a860e9ec.png";